module.exports = __webpack_public_path__ + "static/media/buddy_bundle-mb-en.578229fc.jpg";